import { Component, HostListener, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";

@Component({
    selector: "app-popup-change-password",
    templateUrl: "./popup-change-password.component.html",
    styleUrls: ["./popup-change-password.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupChangePasswordComponent implements OnInit, OnDestroy, iEvent {
  public _eventSubscriptions: Array<Subscription> = null;

  public formPasswordChange: UntypedFormGroup = null;

  /**
   * Current correct password
   */
  @Input() correctPassword: string;

  /**
   * Minimum lenght the password shall match; IF UNDEFINED, the fallback value is "4"
   */
  @Input() passwordMinLenght: number;

  constructor(
    private _fb: UntypedFormBuilder,
    private _modalController: ModalController,
    private _eventService: EventService
  ) { }

  ngOnInit() {

    this.passwordMinLenght = this.passwordMinLenght ??= 4;

    this.initializeForm();
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Close button: dismisses without data, the same result as a tap on the backdrop
   */
  public onClickClose(): void {
    this._modalController.dismiss();
  }

  /**
   * Handle click save button
   */
  public async onClickSave(): Promise<void> {
    await this._modalController.dismiss(this.formPasswordChange.value.password);
  }

  /**
   * Avoid prompt number in custom input text // ///
   *
   * @param event
   * @returns
   */
  public promptOnlyNumber(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public promptOnlyNumberKey(event): boolean {
    let reg = new RegExp("[^0-9]");
    if (reg.test(event.target.value)) {
      return false;
    } else {
      return true;
    }
  }

  public removeNonNumericsFromInputs(event: any) {
    event.target.value = this.removeNonNumerics(event.target.value);
  }
  private removeNonNumerics(inputStr: string) {
    let reg = new RegExp("[^0-9]");
    var newStr = inputStr.replace(reg, "");
    return newStr;
  }

  /**
   * Initialize form data //
   */
  private initializeForm(): void {
    this.formPasswordChange = this._fb.group(
      {
        password: new UntypedFormControl(this.correctPassword, [
          Validators.required,
          Validators.minLength(this.passwordMinLenght),
          //Validators.pattern('[0-9]+')
        ]),
        reconfirmPassword: new UntypedFormControl(this.correctPassword, [
          Validators.required,
          Validators.minLength(this.passwordMinLenght),
          //Validators.pattern('[0-9]+')
        ]),
      },
      { validators: this.checkSamePassword }
    );
  }

  /**
   * Check if prompt input password is same.
   * It return null if are same otherwise return error
   *
   * @returns
   */
  private checkSamePassword(control: AbstractControl): ValidationErrors | null {
    if (control.get("password") && control.get("reconfirmPassword")) {
      if (
        control.get("password").value !== control.get("reconfirmPassword").value
      ) {
        return { passwordMissmatch: true };
      }
    }

    return null;
  }
}
